<div class="loading-screen">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>
